import request from '@/plugin/axios'

export function addOrUpdateFinaDetail(obj) {
    return request({
        url: '/api/case/czFinancialDetail/addOrUpdateFinaDetail',
        method: 'post',
        data: obj
    })
}

export function updateFinancialDetail(obj) {
    return request({
        url: '/api/case/czFinancialDetail/updateFinancialDetail',
        method: 'post',
        data: obj
    })
}

export function deleteFinancialDetail(id) {
    return request({
        url: '/api/case/czFinancialDetail/delete/' + id,
        method: 'delete'
    })
}

